import { mapPicture, resetPassword, updateProfile, uploadPicture } from "api/user";

export const passwordConfig = {
  resetPassword
};

export const profileConfig = {
  getUserInfo: null,
  updateProfile,
  mapPicture,
  uploadPicture,
  passwordConfig: passwordConfig
};